import { createContext, useContext, useEffect } from "react";

export const OnboardingStepActiveContext = createContext(true);

// Dialog portals live outside the hidden step. Close and reset them when the
// saved position changes, while the step retains its drafts and upload queue.
export const useStepDialog = (open: boolean, onClose: () => void) => {
  const active = useContext(OnboardingStepActiveContext);
  useEffect(() => {
    if (!active && open) onClose();
  }, [active, open, onClose]);
  return active && open;
};
